<div class="modal-header">
    <h5 class="modal-title">{{title}}</h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form autocomplete="off" [formGroup]="form" (ngSubmit)="onConfirme()">
    <div class="modal-body">
      <div class="col-md-12">
        <!-- Détails sur le bien CONCERNE -->
        <div class="row">
          <span class="badge badge-secondary my-2 f-14 width">
            Détails
          </span>
        </div>
        <div class="form-group" *ngIf="type === 'HOUSE'">
          <div class="row mb-2">
            <div class="col-md-4">
              <app-entity-finder [class]="'Owner'" [groups]="['owner']" [required]="true" [label]="'Bailleur'"
                (uuid)="setOwnerUuid($event)" [selected]="ownerSelected"
                [placeholder]="'Sélectionnez un bailleur'">
              </app-entity-finder>
            </div>
            <div class="col-md-8">
              <div *ngIf="isLoadingHouse" class="spinner-container">
                <div class="spinner"></div>
              </div>
              <label for="entity">Biens concernés <span class="asterix">*</span></label>
              <ng-select [multiple]="true" class="form-control" formControlName="entity" [ngClass]="{
                  'is-invalid': submit && f.entity.errors, 'is-valid': submit && f.entity.valid }">
                  <ng-option *ngFor="let item of houses" [value]="item?.uuid" >{{item?.nom}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="type === 'PROMOTION'">
          <div class="row mb-2">
            <div class="col-md-12">
              <label for="entity">Programmes concernés <span class="asterix">*</span></label>
              <ng-select [multiple]="true" class="form-control" formControlName="entity" [ngClass]="{
                  'is-invalid': submit && f.entity.errors, 'is-valid': submit && f.entity.valid }">
                  <ng-option *ngFor="let item of promotions" [value]="item?.uuid" >{{item?.libelle}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="type === 'SUBDIVISION'">
          <div class="row mb-2">
            <div class="col-md-12">
              <label for="entity">Projet de lotissement concernés <span class="asterix">*</span></label>
              <ng-select [multiple]="true" class="form-control" formControlName="entity" [ngClass]="{
                  'is-invalid': submit && f.entity.errors, 'is-valid': submit && f.entity.valid }">
                  <ng-option *ngFor="let item of lotissements" [value]="item?.uuid" >{{item?.nom}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>

        <div class="row">
          <span class="badge badge-secondary my-2 f-14 width"> Attribution des agents </span>
        </div>
        <div class="form-group">
          <div class="row mb-2">
            <div class="col-md mt-4">
              <dual-list (destinationChange)="setData()" [sort]="keepSorted" [source]="source" [key]="key" [display]="display" [filter]="true"
                [(destination)]="confirmed" height="265px" [format]="format" [disabled]="disabled">
              </dual-list>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button (click)="onClose()" type="button" class="btn btn-secondary text-left" data-dismiss="modal">
        Fermer <i class="feather icon-x-circle"></i>
      </button>
      <button (click)="form.reset()" type="button" class="btn btn-warning">
        Vider <i class="fas fa-broom"></i>
      </button>
      <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
        Enregistrer <i class="feather icon-save"></i>
      </button>
    </div>
  </form>
